import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import TagIcon from "@redotech/redo-web/icon-old/tag.svg";
import { produce } from "immer";
import * as React from "react";
import {
  StepDownstream,
  StepId,
  StepType,
  StepTypeDetailsProps,
} from "../step";

export interface AddConversationTagState {
  next: StepId | undefined;
  tags: { name: string; color: string }[];
  attempted?: boolean;
  customTitle?: string;
}

export const ADD_CONVERSATION_TAG = (
  Details: React.ComponentType<StepTypeDetailsProps<AddConversationTagState>>,
): StepType<AddConversationTagState, ModelStep.AddConversationTag> => ({
  Details: (props: StepTypeDetailsProps<AddConversationTagState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: STEP_TYPE_NAMES[ModelStep.ADD_CONVERSATION_TAG],
  valid(state) {
    return state.next !== undefined && state.tags.length > 0;
  },
  Icon: TagIcon,
  iconColor: "success",
  description(state) {
    return state.tags.length > 0
      ? `Add tags: ${state.tags.map((tag) => tag.name).join(", ")}`
      : "Add a tag to the conversation";
  },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  layout() {
    return BlockLayout.FULL;
  },
  empty: { tags: [], next: undefined },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.ADD_CONVERSATION_TAG,
      tags: state.tags,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      next: id(state.next!),
    };
  },
  fromModel(model, id) {
    return {
      customTitle: model.customTitle,
      tags: model.tags,
      next: id(model.next),
    };
  },
});
